import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Labels from '../../components/translations/translation.json'
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions } from '@mui/material';
//css file
import './emailInfoModal.css';


function EmailInfoModal(props) {

    const [open] = useState(true);
    const [close] = useState(true);

    const handleClose = () => {
      props.callbackClose();
    }

  return (
    <>
      <Dialog aria-labelledby="customized-dialog-title" className='dialog-modal' open={open}>
      <DialogTitle className="dialogTitle-emailInfo" sx={{ m: 0, p: 2 }}>
        {Labels[props.langProp].INFORMATION_MODAL}
          {close ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: '#000',
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent dividers className="dialog-content">
          <DialogContentText className="dialog-content-text">
            {
              props.updateModal ? <span className='textBody-emailInfoModal'>{Labels[props.langProp].EMAIL_UPDATED_MODAL}
              {Labels[props.langProp].RESEND_EMAIL_PARA1} 6 {Labels[props.langProp].RESEND_EMAIL_PARA2}</span> : <span  className='textBody-emailInfoModal'>{Labels[props.langProp].EMAIL_DELETED_MODAL} </span>
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button variant="contained" className="button-ok-emailInfo" onClick={handleClose}>{Labels[props.langProp].OK}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

EmailInfoModal.propTypes = {
  langProp: PropTypes.string,
  updateModal: PropTypes.bool,
  callbackClose: PropTypes.func,
};

export default EmailInfoModal;
